/**
 * Task 222 — the hover card for a glossary term. Fixed-position chip near the
 * hovered <strong> (same out-of-flow posture as the selection menu: never
 * reflows the reading text), flipping below when near the viewport top.
 */
import type { JSX } from "react";
import { BowSigil } from "../components/Wordmark";
import type { Strings } from "../strings/types";
import type { TermCardState } from "./use-term-glossary";

const EDGE = 12;
const GAP = 10;
const FLIP_THRESHOLD = 120;

export function GlossaryCard(props: { card: TermCardState; strings: Strings }): JSX.Element {
  const { card, strings } = props;
  const below = card.top < FLIP_THRESHOLD;
  const viewportW = typeof window !== "undefined" ? window.innerWidth : 1024;
  const x = Math.min(Math.max(card.x, EDGE + 130), viewportW - EDGE - 130);
  const y = below ? card.bottom + GAP : card.top - GAP;

  return (
    <div
      className="creader-termcard"
      data-below={below ? "true" : "false"}
      role="note"
      aria-label={card.entry.term}
      style={{ left: `${x}px`, top: `${y}px` }}
    >
      <div className="creader-termcard__head">
        <BowSigil className="creader-termcard__sigil" />
        <span className="creader-termcard__term">{card.entry.term}</span>
      </div>
      <p className="creader-termcard__gloss">{card.entry.gloss}</p>
      <span className="creader-termcard__foot">{strings.corpusGlossaryLabel}</span>
    </div>
  );
}
